<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>

      <div class="form-group form-row">
        <label :for="safeId('gang')" class="col-sm-4 col-form-label">Gang</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('gang')" v-model.lazy="gang">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('rink')" class="col-sm-4 col-form-label">Platz</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('rink')" v-model="rink" :options="rinkOptions"
                         text-field="label" value-field="value">
          </b-form-select>
        </div>
      </div>

      <div class="form-group form-row" v-if="datasetId1">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Paarung</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId1" :dataset-id="datasetId1"
                         :label-fn="labelFn"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('farbe1')" class="col-sm-4 col-form-label">Farbe 1</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('farbe1')" v-model="farbe1" :options="colorOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('name1')" class="col-sm-4 col-form-label">Name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name1')" v-model.lazy="name1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('info1')" class="col-sm-4 col-form-label">Info 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('info1')" v-model.lazy="info1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('note1')" class="col-sm-4 col-form-label">Note 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('note1')" v-model.lazy="note1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('farbe2')" class="col-sm-4 col-form-label">Farbe 2</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('farbe2')" v-model="farbe2" :options="colorOptions">
          </b-form-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('name2')" class="col-sm-4 col-form-label">Name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name2')" v-model.lazy="name2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('info2')" class="col-sm-4 col-form-label">Info 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('info2')" v-model.lazy="info2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('note1')" class="col-sm-4 col-form-label">Note 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('note1')" v-model.lazy="note1">
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-8 offset-sm-4">
          <button type="button" class="btn btn-primary" @click="toggleGang">Gang</button>
          <button type="button" class="btn btn-primary" @click="toggleNotenblatt">Notenblatt</button>
          <button type="button" class="btn btn-primary" @click="toggleNoten">Noten</button>
          <button type="button" class="btn btn-primary" @click="toggleZeit">Zeit</button>
        </div>
      </div>

      <clock-control :template-id="templateId"></clock-control>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId1')" class="col-sm-4 col-form-label">Paarungen</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId1')" v-model="datasetId1"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label"></label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="dataset1Columns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternFarbe1')" class="col-sm-4 col-form-label">Farbe 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternFarbe1')" v-model.lazy="patternFarbe1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternName1')" class="col-sm-4 col-form-label">Title 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternName1')" v-model.lazy="patternName1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternInfo1')" class="col-sm-4 col-form-label">Info 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternInfo1')" v-model.lazy="patternInfo1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternNote1')" class="col-sm-4 col-form-label">Note 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternNote1')" v-model.lazy="patternNote1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternFarbe2')" class="col-sm-4 col-form-label">Farbe 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternFarbe2')" v-model.lazy="patternFarbe2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternName2')" class="col-sm-4 col-form-label">Title 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternName2')" v-model.lazy="patternName2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternInfo2')" class="col-sm-4 col-form-label">Info 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternInfo2')" v-model.lazy="patternInfo2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternNote2')" class="col-sm-4 col-form-label">Note 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternNote2')" v-model.lazy="patternNote2">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('datasetId2')" class="col-sm-4 col-form-label">Notenblatt 1</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId2')" v-model="datasetId2"></dataset-select>
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('datasetId3')" class="col-sm-4 col-form-label">Notenblatt 2</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId3')" v-model="datasetId3"></dataset-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <div class="form-group form-row">
          <label :for="safeId('allowSameColor')" class="col-sm-4 col-form-label">Allow same color</label>
          <div class="col-sm-8" style="padding-top: 5px">
            <b-form-checkbox :id="safeId('allowSameColor')" v-model="allowSameColor"></b-form-checkbox>
          </div>
        </div>

        <number-input-group v-model="autoHideSecs" label="Autohide (secs)"></number-input-group>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">Start time</label>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="form-row align-items-end">
                <div class="col">
                  <label :for="safeId('startHours')" class="col-form-label">Hours</label>
                  <input type="number" :id="safeId('startHours')" class="form-control"
                         v-model.number="startHours" min="0" max="99">
                </div>
                <div class="col">
                  <label :for="safeId('startMins')" class="col-form-label">Mins</label>
                  <input type="number" :id="safeId('startMins')" class="form-control"
                         v-model.number="startMins" min="0" max="59">
                </div>
                <div class="col">
                  <label :for="safeId('startSecs')" class="col-form-label">Secs</label>
                  <input type="number" :id="safeId('startSecs')" class="form-control"
                         v-model.number="startSecs" min="0" max="59">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">End time</label>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="form-row align-items-end">
                <div class="col">
                  <label :for="safeId('endHours')" class="col-form-label">Hours</label>
                  <input type="number" :id="safeId('endHours')" class="form-control"
                         v-model.number="endHours" min="0" max="99">
                </div>
                <div class="col">
                  <label :for="safeId('endMins')" class="col-form-label">Mins</label>
                  <input type="number" :id="safeId('endMins')" class="form-control"
                         v-model.number="endMins" min="0" max="59">
                </div>
                <div class="col">
                  <label :for="safeId('endSecs')" class="col-form-label">Secs</label>
                  <input type="number" :id="safeId('endSecs')" class="form-control"
                         v-model.number="endSecs" min="0" max="59">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">Format</label>
          <div class="col-sm-8">
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayHours">Hrs
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayMinutes">Mins
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayTenths">1/10
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayHundredths">1/100
              </label>
            </div>
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapOverlayData, mapOverlayOptions, mapTemplateData, mapTemplateOptions } from '../../utils/index'
import * as mutation from '../../store/mutation-types'
import * as action from '../../store/action-types'
import clockControl from './clock-control.vue'

export default {
  name: 'swiss-wrestling-duel-2026',
  mixins: [templateMixin],
  components: {clockControl},
  data () {
    return {
      rinkOptions: new Array(10).fill(null).map((v, i) => ({label: `${i + 1}`, value: i + 1}))
    }
  },
  computed: {
    ...mapOverlayData(['gang', 'farbe1', 'farbe2', 'name1', 'name2', 'info1', 'info2', 'note1', 'note2']),
    ...mapOverlayData({'recordsNotenblatt1': {default: []}}),
    ...mapOverlayData({'recordsNotenblatt2': {default: []}}),
    ...mapTemplateData(['rink', 'datasetId1', 'recordId1', 'datasetId2', 'datasetId3']),
    ...mapTemplateData({
      /* eslint-disable no-template-curly-in-string */
      patternFarbe1: {default: '${p1_a_farbe}'},
      patternName1: {default: '${p1_lastName} ${p1_firstName} ${p1_a_sterne}'},
      patternInfo1: {default: '${p1_a_verband}, ${p1_a_wohnort}'},
      patternNote1: {default: '${p1_a_note}'},
      patternFarbe2: {default: '${p2_a_farbe}'},
      patternName2: {default: '${p2_lastName} ${p2_firstName} ${p2_a_sterne}'},
      patternInfo2: {default: '${p2_a_verband}, ${p2_a_wohnort}'},
      patternNote2: {default: '${p2_a_note}'}
      /* eslint-enable no-template-curly-in-string */
    }),
    ...mapTemplateOptions({'allowSameColor': false}),
    dataset1 () {
      if (!this.datasetId1) return null
      return this.$store.getters.dataset(this.datasetId1)
    },
    dataset1Columns () {
      if (!this.dataset1) return
      return this.dataset1.columns || []
    },
    dataset2 () {
      if (!this.datasetId2) return null
      return this.$store.getters.dataset(this.datasetId2)
    },
    dataset3 () {
      if (!this.datasetId3) return null
      return this.$store.getters.dataset(this.datasetId3)
    },
    colorOptions () {
      return {'hell': 'Hell', 'dunkel': 'Dunkel'}
    },
    recordsNotenblatt1 () {
      const dataset = this.$store.getters.dataset(this.datasetId2)
      if (!dataset) return []
      const records = [].concat(dataset.records)
      records.sort((a, b) => {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER)
      })
      return records.map(record => {
        return Object.assign({}, record)
      })
    },
    recordsNotenblatt2 () {
      const dataset = this.$store.getters.dataset(this.datasetId3)
      if (!dataset) return []
      const records = [].concat(dataset.records)
      records.sort((a, b) => {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER)
      })
      return records.map(record => {
        return Object.assign({}, record)
      })
    },
    // CLOCK
    ...mapOverlayData(['direction']),
    ...mapOverlayOptions(['displayHours', 'displayMinutes', 'displayTenths', 'displayHundredths']),
    ...mapOverlayOptions({'autoHideSecs': {default: 0}}),
    ...mapTemplateOptions({'startTimeMs': {default: 0}, 'endTimeMs': {default: 0}}),
    startHours: {
      get () {
        return Math.floor(this.startTimeMs / 1000 / 3600)
      },
      set (val) {
        this.setStartTimeMs(val, this.startMins, this.startSecs)
      }
    },
    startMins: {
      get () {
        return Math.floor(this.startTimeMs / 1000 / 60 % 60)
      },
      set (val) {
        this.setStartTimeMs(this.startHours, val, this.startSecs)
      }
    },
    startSecs: {
      get () {
        return this.startTimeMs / 1000 % 60
      },
      set (val) {
        this.setStartTimeMs(this.startHours, this.startMins, val)
      }
    },
    endHours: {
      get () {
        return Math.floor(this.endTimeMs / 1000 / 3600)
      },
      set (val) {
        this.setEndTimeMs(val, this.endMins, this.endSecs)
      }
    },
    endMins: {
      get () {
        return Math.floor(this.endTimeMs / 1000 / 60 % 60)
      },
      set (val) {
        this.setEndTimeMs(this.endHours, val, this.endSecs)
      }
    },
    endSecs: {
      get () {
        return this.endTimeMs / 1000 % 60
      },
      set (val) {
        this.setEndTimeMs(this.endHours, this.endMins, val)
      }
    }
  },
  watch: {
    rink: function (val) {
      const dataset = this.$store.getters.dataset(this.datasetId1)
      if (!dataset || !dataset.fileName) return

      let fileName = dataset.fileName
      const queryStringIndex = fileName.indexOf('?')

      if (queryStringIndex !== -1) {
        const baseUrl = fileName.substring(0, queryStringIndex) // Extract base URL
        const queryString = fileName.substring(queryStringIndex) // Extract query string

        // Use regex to find and replace attributes.platz with the new value
        const updatedQueryString = queryString.replace(/(attributes\.platz=)\d+/, `$1${val}`)

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          })
        }
      }
    },
    recordId1: function (val) {
      if (!val) return
      let datasetRecord = this.$store.getters.dataset(this.datasetId1).records
        .find(r => r.recordId === val)
      if (!datasetRecord) return
      const record = this.mapRecord(datasetRecord)
      this.farbe1 = record.farbe1
      this.name1 = record.name1
      this.info1 = record.info1
      this.note1 = record.note1
      this.farbe2 = record.farbe2
      this.name2 = record.name2
      this.info2 = record.info2
      this.note2 = record.note2
      this._cmd = null
      this.bibNumber1 = datasetRecord['p1_bibNumber']
      this.bibNumber2 = datasetRecord['p2_bibNumber']

      this.updateNotenblatt(datasetRecord['p1_bibNumber'], this.datasetId2)
      this.updateNotenblatt(datasetRecord['p2_bibNumber'], this.datasetId3)
    },
    farbe1: function (val) {
      if (!this.allowSameColor) {
        this.farbe2 = val === 'hell' ? 'dunkel' : 'hell'
      }
    },
    farbe2: function (val) {
      if (!this.allowSameColor) {
        this.farbe1 = val === 'hell' ? 'dunkel' : 'hell'
      }
    },
    recordsNotenblatt1: function (val) {
      let data = {}
      for (var idx = 0; idx < 8; idx++) {
        data[`notenblatt1.zeile${idx + 1}.name`] = ''
        data[`notenblatt1.zeile${idx + 1}.note`] = ''
        data[`notenblatt1.zeile${idx + 1}.resultat`] = ''
      }
      data = val.reduce((result, record, idx) => {
        if (this.bibNumber1 === record['p1_bibNumber']) {
          result[`notenblatt1.zeile${idx + 1}.name`] = record['p2_lastName'] + ' ' + record['p2_firstName'] + ' ' + record['p2_a_sterne']
          result[`notenblatt1.zeile${idx + 1}.note`] = record['p2_a_note']
          result[`notenblatt1.zeile${idx + 1}.resultat`] = record['p2_a_resultat']
        } else {
          result[`notenblatt1.zeile${idx + 1}.name`] = record['p1_lastName'] + ' ' + record['p1_firstName'] + ' ' + record['p1_a_sterne']
          result[`notenblatt1.zeile${idx + 1}.note`] = record['p1_a_note']
          result[`notenblatt1.zeile${idx + 1}.resultat`] = record['p1_a_resultat']
        }
        return result
      }, data)
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: data
      })
    },
    recordsNotenblatt2: function (val) {
      let data = {}
      for (var idx = 0; idx < 8; idx++) {
        data[`notenblatt2.zeile${idx + 1}.name`] = ''
        data[`notenblatt2.zeile${idx + 1}.note`] = ''
        data[`notenblatt2.zeile${idx + 1}.resultat`] = ''
      }
      data = val.reduce((result, record, idx) => {
        if (this.bibNumber2 === record['p1_bibNumber']) {
          result[`notenblatt2.zeile${idx + 1}.name`] = record['p2_lastName'] + ' ' + record['p2_firstName'] + ' ' + record['p2_a_sterne']
          result[`notenblatt2.zeile${idx + 1}.note`] = record['p2_a_note']
          result[`notenblatt2.zeile${idx + 1}.resultat`] = record['p2_a_resultat']
        } else {
          result[`notenblatt2.zeile${idx + 1}.name`] = record['p1_lastName'] + ' ' + record['p1_firstName'] + ' ' + record['p1_a_sterne']
          result[`notenblatt2.zeile${idx + 1}.note`] = record['p1_a_note']
          result[`notenblatt2.zeile${idx + 1}.resultat`] = record['p1_a_resultat']
        }
        return result
      }, data)
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: data
      })
    }
  },
  methods: {
    labelFn (record) {
      return [
        record['p1_bibNumber'] || record['p1_a_startnummer'] || '',
        record['p1_lastName'] || '',
        record['p1_firstName'] || '',
        record['p1_a_note'] || '',
        '-',
        record['p2_bibNumber'] || record['p2_a_startnummer'] || '',
        record['p2_lastName'] || '',
        record['p2_firstName'] || '',
        record['p2_a_note'] || '',
        '-',
        record['a_status']
      ].join(' ')
    },
    mapRecord (record) {
      const result = {}
      const recordMap = {
        farbe1: this.patternFarbe1,
        name1: this.patternName1,
        info1: this.patternInfo1,
        note1: this.patternNote1,
        farbe2: this.patternFarbe2,
        name2: this.patternName2,
        info2: this.patternInfo2,
        note2: this.patternNote2
      }
      for (let k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || ''
        })
      }
      return result
    },
    updateNotenblatt (bibNumber, datasetId) {
      const dataset = this.$store.getters.dataset(datasetId)
      if (!dataset || !dataset.fileName) return

      let fileName = dataset.fileName
      const queryStringIndex = fileName.indexOf('?')

      if (queryStringIndex !== -1) {
        const baseUrl = fileName.substring(0, queryStringIndex) // Extract base URL
        const queryString = fileName.substring(queryStringIndex) // Extract query string

        // Use regex to find and replace participants.bibNumber with the new value
        const updatedQueryString = queryString.replace(/(participants\.bibNumber=)\d+/, `$1${bibNumber}`)

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          })
        }
      }
    },
    toggleGang () {
      this.$store.dispatch(action.OVERLAY_DATA, {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: {'_cmd': 'gang:' + new Date().getTime()}
      })
    },
    toggleNoten () {
      this.$store.dispatch(action.OVERLAY_DATA, {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: {'_cmd': 'noten:' + new Date().getTime()}
      })
    },
    toggleNotenblatt () {
      this.$store.dispatch(action.OVERLAY_DATA, {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: {'_cmd': 'notenblatt:' + new Date().getTime()}
      })
    },
    toggleZeit () {
      this.$store.dispatch(action.OVERLAY_DATA, {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: {'_cmd': 'zeit:' + new Date().getTime()}
      })
    },
    // CLOCK
    setStartTimeMs (hours, mins, secs) {
      this.startTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1)
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down'
    },
    setEndTimeMs (hours, mins, secs) {
      this.endTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1)
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/swiss-wrestling-duel-2026.vue